// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3Htdn","title":"FrontImage_title__1U5VP"};